import { Box } from '@chakra-ui/react'

export const PHOCUSLogo = () => {
    return (
        <Box
            as="svg"
            role="img"
            width="100px"
            height="40px"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 423.12 281.845"
        >
            <g>
                <rect x="140.384" width="141.369" height="141.369" fill="#e9ff84"></rect>
                <path d="M20.49,0h121.369v141.369H.49V20C.49,8.962,9.452,0,20.49,0Z" fill="#e0ff4f"></path>
                <rect x="140.295" y="140.476" width="141.369" height="141.369" fill="#14335e"></rect>
                <path d="M281.751,0h121.369c11.038,0,20,8.962,20,20v121.369h-141.369V0h0Z" fill="#14335e"></path>
                <path d="M0,140.476h141.369v141.369H20c-11.038,0-20-8.962-20-20v-121.369h0Z" fill="#1c4280"></path>
                <path
                    d="M281.346,140.476h141.369v121.369c0,11.038-8.962,20-20,20h-121.369v-141.369h0Z"
                    fill="#1c4280"
                ></path>
                <path
                    d="M76.492,26.286v-.025h-7.336v14.423h7.183v.005c8.44,0,15.307,6.867,15.307,15.307,0,8.353-6.729,15.155-15.05,15.294v-.018h-23.801V26.187h-14.414v91.465h14.414v-31.948h23.544v.005c.06,0,.118-.004.178-.005h.08v-.002c16.265-.14,29.456-13.409,29.456-29.707s-13.247-29.626-29.56-29.709Z"
                    fill="#1c4280"
                ></path>
                <polygon
                    points="231.701 27.376 231.701 71.498 185.42 71.498 185.42 27.376 171.081 27.376 171.081 118.098 185.42 118.098 185.42 85.746 231.701 85.746 231.701 118.098 246.039 118.098 246.039 27.376 231.701 27.376"
                    fill="#1c4280"
                ></polygon>
                <path
                    d="M388.538,80.883v-19.53h0c0-.007,0-.014,0-.022v-.177h-.004c-.108-20.521-16.772-37.125-37.319-37.125s-37.212,16.604-37.319,37.125h-.039v20h.065c.147,20.488,16.795,37.053,37.318,37.053s37.324-16.711,37.324-37.324h-.025ZM374.3,80.883c-.06,12.623-10.268,22.877-22.922,22.954-12.74.077-23.13-10.188-23.207-22.927h-.044v-19.557h.026c.06-12.623,10.268-22.877,22.922-22.954,12.74-.077,23.13,10.188,23.207,22.927h.02v19.557h-.002Z"
                    fill="#e0ff4f"
                ></path>
                <path
                    d="M244.915,220.48v-53.683h-14.306v53.84h.043c-.143,12.551-10.316,22.72-22.917,22.798-12.664.077-23.003-10.068-23.201-22.703h.004v-53.505h-14.306v53.505h.045c.136,20.497,16.789,37.073,37.318,37.073s37.324-16.711,37.324-37.324h-.005Z"
                    fill="#e0ff4f"
                ></path>
                <path
                    d="M385.447,231.054c0-.019.001-.038.001-.057h-.003c-.062-14.533-11.901-26.338-26.426-26.338l-21.831-.071c-6.787,0-12.308-5.503-12.344-12.28.025-6.788,5.551-12.303,12.341-12.303l21.646.013c6.81,0,12.348,5.54,12.348,12.349h14.103c0-14.585-11.866-26.452-26.447-26.452l-21.646-.013c-14.547,0-26.387,11.806-26.448,26.339h-.004c0,.024.002.048.002.072,0,.014-.001.027-.001.041h.002c.062,14.533,11.901,26.338,26.426,26.338l21.83.071c6.79,0,12.314,5.509,12.345,12.292-.031,6.783-5.555,12.291-12.31,12.291l-21.405-.106c-6.81,0-12.349-5.54-12.349-12.349h-14.103c0,14.585,11.867,26.452,26.417,26.452l21.404.106c14.547,0,26.386-11.805,26.448-26.338h.003c0-.019-.001-.038-.001-.057Z"
                    fill="#e0ff4f"
                ></path>
            </g>
            <path
                d="M67.607,244.384c-12.74.077-23.13-10.188-23.207-22.927l.005-19.627h0c.06-12.623,10.268-22.877,22.922-22.954,10.674-.065,19.695,7.133,22.386,16.961h14.592c-2.868-17.763-18.266-31.331-36.839-31.331-20.318,0-36.831,16.237-37.302,36.441l-.018,20.631c.08,20.545,16.757,37.176,37.321,37.176,18.362,0,33.615-13.263,36.731-30.729h-14.665c-2.858,9.416-11.571,16.296-21.927,16.359Z"
                fill="#e0ff4f"
            ></path>
        </Box>
    )
}
